import { REALM } from "./index";

// Browser tab title + favicon — index.html itself is static (plain CRA, no per-realm HTML
// templating), so these are swapped here at runtime instead, the same "REALM picks the asset"
// approach as every other per-brand resource in this folder. Only NiksFit has its own icon set
// so far (public/favicon*-niksfit.*, apple-touch-icon-niksfit.png) — HitFit's existing
// index.html tags are left completely untouched when REALM isn't "niksfit".
export function applyBrandHead() {
  if (REALM !== "niksfit") return;

  document.title = "Niksfit";

  document
    .querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]')
    .forEach((link) => {
      const href = link.getAttribute("href");
      if (!href || href.includes("-niksfit.")) return;
      const niksfitHref = href.replace(/(\.[^./]+)$/, "-niksfit$1");
      link.setAttribute("href", niksfitHref);
    });
}
